import React, { Component } from 'react';
import ObjectsListingItem from './ObjectsListingItem';

class ObjectsListing extends Component {

    constructor(){
        super();
        this.state = {
            selectedObject: 0
        }

        this.handleDetailsRequested = this.handleDetailsRequested.bind(this);
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handleShowRoom = this.handleShowRoom.bind(this);
        this.handleShowCart = this.handleShowCart.bind(this);
        this.handleScrollTo = this.handleScrollTo.bind(this);
    }

    handleDetailsRequested(id){
        this.setState({selectedObject: id});
    }

    handleAddToCart(cartItem){
        this.props.onAddToCart(cartItem);
    }

    handleShowRoom(item){
        this.props.onShowRoom(item);
    }

    handleShowCart(){
        this.props.onShowCart();
    }

    handleScrollTo(position){
        if(this.props.onScrollTo !== undefined){
            this.props.onScrollTo(position)
        }        
    }

    render(){        

        const items = this.props.items.map(
            (object) => {

                //display only selected room
                /*if(this.state.selectedObject !== 0 && this.state.selectedObject !== object.id){
                    return false;
                }*/

                //filter by number of persons
                let bedMultiplier = 1;
                if(object.bedsize === 'kingsize' || object.bedsize === 'double'){
                    bedMultiplier = 2
                }
                if(this.props.numPersons > object.numbeds*bedMultiplier){
                    return false;
                }

                //filter by breakfast
                if(this.props.breakfast && !object.breakfast){
                    return false;
                }

                //filter by double bed
                if(this.props.doublebed && object.bedsize !== 'double' && object.bedsize !== 'kingsize' ){
                    return false;
                }

                //filter by kitchen
                if(this.props.kitchen && !object.kitchen){
                    return false;
                }

                //filter by place for kids
                if(this.props.placeforkids && !object.placeforkids){
                    return false;
                }

                //filter by pets allowed
                if(this.props.petsallowed && !object.petsallowed){
                    return false;
                }
                
                return (
                    <ObjectsListingItem 
                        key={object.id} 
                        data_key={object.id} 
                        object={object} 
                        numPersons={this.props.numPersons}
                        searchReason={this.props.searchReason}
                        breakfast={this.props.breakfast}
                        doublebed={this.props.doublebed}
                        kitchen={this.props.kitchen}
                        placeforkids={this.props.placeforkids}
                        petsallowed={this.props.petsallowed}
                        promocode={this.props.promocode}
                        dateInterval={this.props.dateInterval}
                        onDetailsRequest={this.handleDetailsRequested}
                        onAddToCart={this.handleAddToCart}
                        onShowRoom={this.handleShowRoom}
                        onShowCart={this.handleShowCart} 
                        onScrollTo={this.handleScrollTo}   
                        isMobile = {this.props.isMobile}                  
                    />
                )
            }
        );        
        
        return (
            <div className="listing">
                 {items}
            </div>
        );       
        
    }

}

export default ObjectsListing;